import { loadMtaData } from '../api/mtaApi.js';
import { createStationIndexes } from '../domain/stations.js';
import { normalizeTrainResponse } from '../domain/trains.js';
import { createBottomSheet } from '../ui/bottomSheet.js';
import { enhanceBottomSheet, enhanceLegacyModalGestures } from '../ui/legacyModalGestures.js';

export function createClientApp(options = {}) {
  const sheet = createBottomSheet({
    title: 'AP Transit',
    content: '<p>New bottom sheet is ready.</p>',
  });

  const state = {
    stations: [],
    stationIndexes: createStationIndexes([]),
    trains: {},
  };
  let legacyModalGestures = null;

  async function loadStations() {
    const stations = await loadMtaData('mtaStationsJson');
    state.stations = Array.isArray(stations) ? stations : [];
    state.stationIndexes = createStationIndexes(state.stations);
    return state.stations;
  }

  async function loadTrains() {
    const response = await loadMtaData('mtaTrainInfo');
    state.trains = normalizeTrainResponse(response);
    return state.trains;
  }

  function init() {
    const rootId = options.rootId || 'vite-app-root';
    const root = document.getElementById(rootId);

    if (root) {
      root.dataset.apClient = 'ready';
      root.hidden = true;
    }

    legacyModalGestures = enhanceLegacyModalGestures(document);

    return app;
  }

  function openSheet(params) {
    sheet.open(params);
  }

  const app = {
    init,
    state,
    api: {
      loadMtaData,
      loadStations,
      loadTrains,
    },
    sheet: {
      open: openSheet,
      close: sheet.close,
      setContent: sheet.setContent,
      destroy: sheet.destroy,
    },
    legacyModals: {
      enhance(sheet) {
        return enhanceBottomSheet(sheet);
      },
      refresh() {
        if (legacyModalGestures) legacyModalGestures.destroy();
        legacyModalGestures = enhanceLegacyModalGestures(document);
      },
    },
  };

  return app;
}
